<div class="alert alert-danger" *ngIf="hasErrors">
    <p>
        <strong *ngIf="title">
            {{title}}
        </strong>
        <strong *ngIf="!title">
            {{ 'error.validation-title' | translate }}
        </strong>
    </p>
    <ul>
        <li *ngFor="let error of errorMessages">
            {{ error.translationCode | translate:error.params }}
        </li>
    </ul>
</div>
